import { rest } from 'msw'

import { PROJECT_ID, PROJECT_ID_WITH_NO_ENVS } from '__test-utils__/ids'

import { useMergeResponses } from 'api/hooks/useMerge/useMerge.responses'

const buildUri = (projectId: string) => {
  return `projects/${projectId}/merges`
}

const stubForProject = (projectId: string) =>
  rest.post(buildUri(projectId), async (req, res, ctx) => {
    const body = await req.json()
    if (body.sourceCommitId === '500') {
      return res(ctx.status(500))
    } else if (body.targetBranchName === 'branchNotFound') {
      return res(
        ctx.status(404),
        ctx.set('content-type', 'application/problem+json'),
        ctx.json({
          type: 'working-tree/branch_not_found',
          title: 'Not found',
          status: 404
        })
      )
    } else {
      return res(ctx.status(201), ctx.json(useMergeResponses))
    }
  })

export const useStubMerge = (baseUrl = '', project = PROJECT_ID) => {
  return rest.post(`${baseUrl}/${buildUri(project)}`, async (req, res, ctx) => {
    const body = await req.json()
    if (body.sourceCommitId === '500') {
      return res(ctx.status(500))
    } else {
      return res(ctx.status(201), ctx.json(useMergeResponses))
    }
  })
}

export const useMergeHandlers = [
  stubForProject(PROJECT_ID),
  stubForProject('test-project'),
  stubForProject(PROJECT_ID_WITH_NO_ENVS)
]
